export enum RegistrationStatus {
  'NONE' = 'NONE',
  'VERIFICATION_REQUIRED' = 'VERIFICATION_REQUIRED',
  'USER_INFO_REQUIRED' = 'USER_INFO_REQUIRED',
  'COMPLETED' = 'COMPLETED'
}
